import { FormLabel, RadioGroup } from '@mui/material';
import FormControl from "@mui/material/FormControl";


/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 * @Description Group Radio Button with dynamic content
 * @param String trans: Text for the label (optional)
 * @param JSX.Element children: List of radio buttons (required)
 * @param Boolean disabled: Enable/disable Group Radio Button (optional)
 * @param {string} [classTitle] - Additional CSS class for customizing the label (optional).
 *  @param {string} [props.className] - Additional CSS class for customizing the root FormControl (optional).
 * @returns {JSX.Element}
 */
const CustomRadioGroup = ({ trans, children, disabled = false, classTitle = "", className="" }) => {
    return (
        <>
            <FormControl component="fieldset" variant="standard" className={className}>
                <FormLabel disabled={disabled} className={`'custom-radio-css' ${classTitle}`}>
                    {trans}
                </FormLabel>
                <RadioGroup className={"mt-10px"}>
                    {children}
                </RadioGroup>
            </FormControl>
        </>
    );
};

export default CustomRadioGroup;
